import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';

import { IconInformation } from 'src/assets/icons/IconInformation';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { getChannelPerformanceLabel } from 'src/data/channel';
import { SOCIAL_CHANNELS } from 'src/data/performance';

import { useStyles } from './useStyles';

export const EmptyStateRow = ({
  channel,
  isChannelConnected,
  allAccountsConnected,
  anyAccountConnected,
}) => {
  const styles = useStyles();

  const item = SOCIAL_CHANNELS.includes(channel) ? 'page' : 'account';

  if (!allAccountsConnected && anyAccountConnected) {
    return null;
  }

  return (
    <TableRow>
      <TableCell
        colSpan={3}
        className={!anyAccountConnected && isChannelConnected ? styles.noAccountsCell : null}
      >
        {allAccountsConnected && (
          <CustomTypography
            className={styles.alreadyConnected}
            variant={TYPOGRAPHY_VARIANT.regular14}
          >
            There is nothing to show, all ad accounts are already connected.
          </CustomTypography>
        )}
        {!anyAccountConnected && (
          <>
            {isChannelConnected ? (
              <CustomTypography
                className={styles.textEmpty}
                variant={TYPOGRAPHY_VARIANT.regular14}
              >
                <IconInformation /> Looks like there are no {item}s in your{' '}
                {getChannelPerformanceLabel(channel)}
              </CustomTypography>
            ) : (
              <CustomTypography
                className={styles.unauthorizedText}
                variant={TYPOGRAPHY_VARIANT.regular14}
              >
                Please complete the authentication process with{' '}
                {getChannelPerformanceLabel(channel)}
              </CustomTypography>
            )}
          </>
        )}
      </TableCell>
    </TableRow>
  );
};

EmptyStateRow.propTypes = {
  channel: PropTypes.string.isRequired,
  isChannelConnected: PropTypes.bool,
  allAccountsConnected: PropTypes.bool,
  anyAccountConnected: PropTypes.bool,
};

EmptyStateRow.defaultProps = {
  isChannelConnected: false,
  allAccountsConnected: false,
  anyAccountConnected: false,
};
